"use strict";

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var optim_1 = require("../optim");

var shapes_1 = require("./shapes");

var lodash_1 = require("lodash");

var seedrandom_1 = __importDefault(require("seedrandom")); // Maximum distance to randomly initalize a port from its center.


var kPortOffset = 0.2;
/**
 * Transform lightweight `NodeSchema` and `EdgeSchema` data structures into `Node` and `Edge`
 * objects. See documentation for `NodeSchema` and `EdgeSchema` for more details.
 * @param nodeSchemas
 * @param edgeSchemas
 * @param config
 *     `shapeCreator`: Function converting `ShapeSchema` to `Shape`.
 *     `portLocation`: Location to assign to port if unspecified. (default: 'center')
 */

function fromSchema(nodeSchemas, edgeSchemas) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$shapeCreator = _ref.shapeCreator,
      shapeCreator = _ref$shapeCreator === void 0 ? shapes_1.fromShapeSchema : _ref$shapeCreator,
      _ref$portLocation = _ref.portLocation,
      portLocation = _ref$portLocation === void 0 ? 'center' : _ref$portLocation;

  // Build nodes, initializing points and dimensions if needed.
  var nodeIdToIdx = new Map();
  var nodes = nodeSchemas.map(function (_ref2, idx) {
    var id = _ref2.id,
        center = _ref2.center,
        shape = _ref2.shape,
        fixed = _ref2.fixed,
        children = _ref2.children,
        ports = _ref2.ports,
        meta = _ref2.meta;
    if (!id) throw Error("Invalid NodeId: ".concat(id));
    if (nodeIdToIdx.has(id)) throw Error("Duplicate NodeId: ".concat(id));
    nodeIdToIdx.set(id, idx); // Generate pseudprandom point for center based on NodeId.

    var rand = seedrandom_1.default(id);
    var centerpt = center ? new optim_1.Vector(center.x, center.y) : new optim_1.Vector(rand(), rand());
    return {
      id: id,
      center: centerpt,
      shape: shapeCreator(shape || {
        type: 'rectangle',
        width: 1,
        height: 1
      }, centerpt),
      fixed: fixed || false,
      children: children || [],
      ports: ports ? lodash_1.mapValues(ports, function (_ref3) {
        var location = _ref3.location,
            order = _ref3.order,
            point = _ref3.point;
        return {
          location: location || portLocation,
          order: order,
          point: point ? new optim_1.Vector(point.x, point.y) : new optim_1.Vector(centerpt.x + kPortOffset * rand(), centerpt.y + kPortOffset * rand())
        };
      }) : {},
      meta: meta
    };
  });
  nodes.forEach(function (node) {
    return node.children = node.children.map(function (id) {
      var childIdx = nodeIdToIdx.get(id);
      if (childIdx === undefined) throw Error("Invalid child NodeId: ".concat(id, ", parent ").concat(node.id));
      return nodes[childIdx];
    });
  }); // Get the endpoint on the source/target node, or create a new one exclusively for the edge.

  function processEndpoint(edgeId, type, nodeId, port) {
    var idx = nodeIdToIdx.get(nodeId);
    if (idx === undefined) throw Error("Invalid ".concat(type, " NodeId: ").concat(nodeId, ", edge ").concat(edgeId));
    var node = nodes[idx];
    var point;

    if (port) {
      if (port in node.ports) {
        point = node.ports[port].point;
      } else {
        throw Error("Invalid ".concat(type, " port name: ").concat(port, ", ").concat(type, " ").concat(nodeId, ", edge ").concat(edgeId));
      }
    } else {
      var rand = seedrandom_1.default("".concat(edgeId, "-").concat(type));
      port = "_".concat(edgeId);
      point = new optim_1.Vector(node.center.x + kPortOffset * rand(), node.center.y + kPortOffset * rand());
      node.ports[port] = {
        point: point,
        location: portLocation
      };
    }

    return {
      id: nodeId,
      port: port,
      node: node,
      point: point
    };
  } // Build edges, establishing references to endpoints.


  var edgeIdToIdx = new Set();
  var edges = edgeSchemas.map(function (_ref4) {
    var id = _ref4.id,
        source = _ref4.source,
        target = _ref4.target,
        path = _ref4.path,
        meta = _ref4.meta;
    if (!id) throw Error("Invalid EdgeId: ".concat(id));
    if (edgeIdToIdx.has(id)) throw Error("Duplicate EdgeId: ".concat(id));
    edgeIdToIdx.add(id);
    var s = processEndpoint(id, 'source', source.id, source.port);
    var t = processEndpoint(id, 'target', target.id, target.port);
    return {
      id: id,
      source: s,
      target: t,
      path: path ? path.map(function (_ref5) {
        var x = _ref5.x,
            y = _ref5.y;
        return new optim_1.Vector(x, y);
      }) : [s.point, t.point],
      meta: meta
    };
  });
  return {
    nodes: nodes,
    edges: edges
  };
}

exports.fromSchema = fromSchema; // TODO: Allow taking any Iterator<Node>, Iterator<Edge>.

function toSchema(nodes, edges) {
  var nodeSchemas = nodes.map(function (node) {
    return {
      id: node.id,
      center: {
        x: node.center.x,
        y: node.center.y
      },
      shape: node.shape.toSchema(),
      fixed: node.fixed,
      children: node.children.map(function (child) {
        return child.id;
      }),
      ports: Object.fromEntries(Object.entries(node.ports).map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            name = _ref7[0],
            _ref7$ = _ref7[1],
            location = _ref7$.location,
            order = _ref7$.order,
            point = _ref7$.point;

        return [name, {
          location: location,
          order: order,
          point: {
            x: point.x,
            y: point.y
          }
        }];
      })),
      meta: node.meta
    };
  });
  var edgeSchemas = edges.map(function (edge) {
    return {
      id: edge.id,
      source: {
        id: edge.source.id,
        port: edge.source.port
      },
      target: {
        id: edge.target.id,
        port: edge.target.port
      },
      path: edge.path.map(function (point) {
        return {
          x: point.x,
          y: point.y
        };
      }),
      meta: edge.meta
    };
  });
  return {
    nodeSchemas: nodeSchemas,
    edgeSchemas: edgeSchemas
  };
}

exports.toSchema = toSchema;